import { render, staticRenderFns } from "./pos-clientStatements.vue?vue&type=template&id=202291aa"
import script from "./pos-clientStatements.vue?vue&type=script&lang=js"
export * from "./pos-clientStatements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports